import React, { useState } from 'react'
import useDialogState from '@/hooks/use-dialog-state'
import type { AdminAnnouncement } from '../types/admin-announcement'

type AdminAnnouncementsDialogType = 'create' | 'update' | 'delete'

type AdminAnnouncementsContextType = {
  open: AdminAnnouncementsDialogType | null
  setOpen: (str: AdminAnnouncementsDialogType | null) => void
  currentRow: AdminAnnouncement | null
  setCurrentRow: React.Dispatch<React.SetStateAction<AdminAnnouncement | null>>
}

const AdminAnnouncementsContext =
  React.createContext<AdminAnnouncementsContextType | null>(null)

export function AdminAnnouncementsProvider({
  children,
}: {
  children: React.ReactNode
}) {
  const [open, setOpen] = useDialogState<AdminAnnouncementsDialogType>(null)
  const [currentRow, setCurrentRow] = useState<AdminAnnouncement | null>(null)

  return (
    <AdminAnnouncementsContext
      value={{ open, setOpen, currentRow, setCurrentRow }}
    >
      {children}
    </AdminAnnouncementsContext>
  )
}

// eslint-disable-next-line react-refresh/only-export-components
export const useAdminAnnouncements = () => {
  const context = React.useContext(AdminAnnouncementsContext)

  if (!context) {
    throw new Error(
      'useAdminAnnouncements has to be used within <AdminAnnouncementsProvider>'
    )
  }

  return context
}
